import '@crasman/branch-bar/styles.css';
import { branchBar } from '@crasman/branch-bar';
import './modules/register-service-worker';
import navigation from './modules/nagivation';
import GmtEventPusher from './gtm-event-pusher'; //to-do: add npm version

// See https://www.npmjs.com/package/@crasman/branch-bar for settings
branchBar.init();
navigation.init();
GmtEventPusher.init();

const siteSearchContainer = document.getElementsByClassName('site-search--desktop')[0];

if (siteSearchContainer) {
  import('./modules/site-search').then(({ default: SiteSearch }) => {
    new SiteSearch(siteSearchContainer);
  });
}

const formElement = document.querySelector('form');
if (formElement) {
  import('./modules/multiselect').then(multiselect => multiselect.default.init());

  const vehicleSearchElement = document.getElementById('vehicle-search');
  if (vehicleSearchElement) {
    import('./modules/vehicle-search').then((vehicleSearch) => vehicleSearch.default.init());
    import('./modules/analytics').then(analytics => analytics.default.vehicleSearchAnalytics());
  }

  const selectFilters = document.querySelector('.js-filter-models');
  if (selectFilters) {
    import('./modules/filter-select').then(fs => fs.default.init());
  }

  //init number range
  import('./modules/number-range').then((range) => {
    range.default.init();
  });

  //init stage forms
  import('./modules/stage-forms').then((stageForms) => {
    stageForms.default.init();
  });
}

const articleCarouselElement = document.querySelector('.article-carousel');
if (articleCarouselElement) {
  import('./modules/article-carousel').then((articleCarousel) => articleCarousel.init());
}

const vehicleCarouselElement = document.querySelector('.vehicle-carousel');
if (vehicleCarouselElement) {
  import('./modules/vehicle-carousel').then((vehicleCarousel) => vehicleCarousel.init());
}

const vehicle360Image = document.querySelector('#autokuva360');
if (vehicle360Image) {
  import('./modules/vehicle-360-image').then(
    ({ Vehicle360ImageModal }) => new Vehicle360ImageModal()
  );
}


const heroVehicleSearchElement = document.querySelector('.hero-vehicle-search');
if (heroVehicleSearchElement) {
  import('./modules/hero-vehicle-search').then((heroVehicleSearch) => heroVehicleSearch.default.init());
}

const vehicleImageCarousel = document.querySelector('.vehicle-image-carousel');
if (vehicleImageCarousel) {
  import('./modules/vehicle-image-carousel').then((vehicleImageCarousel) => vehicleImageCarousel.init());
}

const accordionElements = document.querySelectorAll('accordion');

import('./modules/accordion').then((Accordion) => {
  accordionElements.forEach( element => new Accordion(element) );
});

const vehiclePage = document.querySelector('.vehicle-page');
if (vehiclePage) {
  import('./modules/tabbed-details').then((tabbedDetails) => tabbedDetails.default.init());
  import('./modules/funding-calculator').then((fundingCalculator) => fundingCalculator.default.init());
}

if (document.getElementsByClassName('hero-vehicle-search')) {
  import('./modules/analytics').then(analytics => analytics.default.heroVehicleSearchAnalytics());
}

if (document.getElementById('vehicle-search-watcher-form')) {
  import('./modules/analytics').then(analytics => analytics.default.searchWatcherAnalytics());
}

if (document.querySelector('.stage-form')) {
  import('./modules/contact-forms').then(contactForms => contactForms.default.init());
}

if (document.querySelector('.stage-form')) {
  import('./modules/contact-forms').then((contactForms) => contactForms.default.init());
}

if (document.querySelectorAll('[data-optimize-experiment-id]').length) {
  import(/* webpackChunkName: 'google-optimize' */ './modules/google-optimize').then(({ default: { init } }) => {
    init();
  });
}

const accordions = document.querySelectorAll('.accordion');

if (accordions.length > 0) {
  import('./modules/accordion').then((accordion) => {
    const Accordion = accordion.default;

    //Basic information item is automaticly open on Desktop sizes
    const showBasicInformation = window.innerWidth > 768;

    Accordion.init(accordions, {
      accordionItems: {
        'tab-1': { classes: showBasicInformation ? ['show'] : [] },
        'tab-3': { classes: showBasicInformation ? ['show'] : [] },
      },
    });
  });
}

if(document.getElementById('funding-form')) {
  import('./modules/funding-form').then(fundingForm => fundingForm.default);
}

const dropdowns = document.querySelectorAll('.dropdown');

if (dropdowns.length > 0) {
  import('./modules/dropdown').then((dropdownModule) => {
    const { default: dropdownInit } = dropdownModule;
    dropdowns.forEach( dropDown => dropdownInit(dropDown) );
  });
}
